import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import Step from "@fae/source/models/Step.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import ProgressReport from "@fae/source/data/games/school/views/ProgressReport.jsx"

function ChapterSummary({units, messages}) {
    messages = messages || {}
    return PlotSteps.CustomViewModal({
        "isUnskippable": false,
        "view": (stage) => {
            if(stage == undefined) return
            return (
                <div class="SchoolChapterSummary">
                    <div class="Sidebar">
                        <div class="Declaration">Progress</div>
                        {false && <section class="GraphSection">
                            <span class="Text">TODO: graph of levels over time vs par</span>
                        </section>}
                        <section class="UnitSection">
                            <ProgressReport unit={units["nerd"]} message={messages["nerd"]}/>
                            <ProgressReport unit={units["punk"]} message={messages["punk"]}/>
                            <ProgressReport unit={units["goth"]} message={messages["goth"]}/>
                        </section>
                    </div>
                </div>
            )
        }
    })
}

export default function() {
    return function(stage) {
        let steps = []

        const unitKeys = ["nerd", "punk", "goth"]

        steps.push(ChapterSummary({
            "units": {
                "nerd": {...stage.units["nerd"], ...stage.player.units["nerd"]},
                "punk": {...stage.units["punk"], ...stage.player.units["punk"]},
                "goth": {...stage.units["goth"], ...stage.player.units["goth"]},
            }
        }))
        steps.push(ChapterSummary({
            "units": {
                "nerd": {...stage.units["nerd"]},
                "punk": {...stage.units["punk"]},
                "goth": {...stage.units["goth"]},
            }
        }))

        // console.log("updating experience if alive or dead")
        unitKeys.forEach((unitKey) => {
            const unit = stage.units[unitKey]
            if(unit == undefined) return
            if(unit.affiliation != "good") return
            let experience = unit.experience
            if(unit.isDead) {
                experience += 1
            } else {
                experience += 2
            }
            experience = Math.min(experience, unit.maxexperience)
            unit.experience = experience
            // steps.push({
            //     "deltastages": [
            //         {
            //             "unit": {
            //                 "key": unit.key,
            //                 "experience": experience
            //             }
            //         }
            //     ]
            // })
        })

        // TOOD: move this into a subsomething function
        const messages = {}
        unitKeys.forEach((unitKey) => {
            if(stage.units[unitKey] == undefined) return
            if(stage.units[unitKey].affiliation != "good") return
            if(stage.units[unitKey].isDead) {
                messages[unitKey] = "Learned. +1xp"
            } else {
                messages[unitKey] = "Survived!! +2xp"
            }
        })
        steps.push(ChapterSummary({
            "units": {
                "nerd": stage.units["nerd"],
                "punk": stage.units["punk"],
                "goth": stage.units["goth"],
            },
            "messages": messages
        }))

        return steps
    }
}
